module.exports = __webpack_public_path__ + "static/media/search.59e8015e.svg";